import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';

import cView from './cView';

import i14v1a from './i14v1a';

export default class iStg1 extends cView { // 団体用 home

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = {
      name: 'ホーム'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

$clp_loadLists = () => [ // 親を上書き
/*
  i14v1a.op_loadDtl({
    elm: 'i14r',
    fst: global.t?.state.sgcd_cmnStgs?.c20r_fst,
    op_atrAll: () => new Promise( _o_end1 => {
      let _d_i14rs = global.t?.state.sdld_i14rDtlsss.i14r[0];
      global.t?.setState({
        s_rsv1: _d_i14rs.d_flds.i14ri71s, // 設定説明文1
        s_rsv2: _d_i14rs.d_flds.i14ri81s, // 設定説明文2
        s_acn1: _d_i14rs.d_flds.i14ri72s, // 設定説明文1
        s_acn2: _d_i14rs.d_flds.i14ri82s, // 設定説明文2
        s_stg1: _d_i14rs.d_flds.i14ri73s, // 設定説明文1
      }, () => {
        _o_end1();
      })
    }),
  })
*/
];

  render() {

    let _l0 = [];
    let _l1 = [];
    let _l2 = [];
    let _n_cnt = 0;

    Object.keys(global.t?.state.sgcdd_menuDefss ?? {})
    .map( ( _pageName, _idx) => {

      if (global.t?.state.sgcdd_menuDefss[_pageName].c40rt11i == 20) _n_cnt += 1;

      if (global.t?.state.sgcdd_menuDefss[_pageName].c40rt11i == 10) {
        let _o = (
          ce.c(ce.Box, {
            key: _idx,
            stlCta: {
//              height: ic.s(12),
              height: ic.s(10),
              width: ic.gn_maxBdyW / 3,
//              width: ic.gn_maxBdyW / 4,
              flexDirection: 'column',
              justifyContent: 'space-around',
              alignItems: 'center',
            }
          }, [

            ce.c(ce.Msg, {
              key: -1,
              pfx: '',
              stlCta: {
                height: ic.s(2),
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              },
              stlPfx: {
                textAlign: 'center',
              },
            }),

            ce.c(ce.Btn, {
              key: -2,
              b_vsb: true,
              b_rvs: false,
              pfx: global.t?.state.sgcdd_menuDefss[_pageName].c40rc31s,
              o_onPrs: () => {
                let _d_pageInfs = {
                  sgc_pageRole: global.t?.state.sgc_pageRole,
                  sgc_pageName: _pageName,
                  sgc_pageMode: 'show',
                };
                cf.myRN_move_fwd(_d_pageInfs);
              },
              stlCta: {
                height: ic.s(6),
              },
              stlBtn: {
                width: ic.gn_btnWLrg * 2,
                backgroundColor: (_pageName == 'c60v1a') ? ic.o_getCcd('p') : ic.o_getCcd('d'), 
              },
              stlPfx: {
                lineHeight: ic.s(6),
                fontSize: ic.s(1.2),
              },
            }),

            ce.c(ce.Msg, {
              key: -3,
              pfx: '',
              stlCta: {
                height: ic.s(6),
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              },
              stlPfx: {
                textAlign: 'center',
              },
            }),
          
          ])
        );
        if (ff.i(_pageName, ['c60v1a'])) {
          _l2.push(_o);
        }
        else if (ff.i(_pageName, ['i1zv1c', 'i1yv1b'])) {
          _l0.push(_o);
        }
        else {
          _l1.push(_o);
        };
      };
    });

    if (_n_cnt > 0) {
      _l2.push(
        ce.c(ce.Box, {
          key: -1,
          stlCta: {
//            height: ic.s(14),
//            height: ic.s(12),
            height: ic.s(10),
            width: ic.gn_maxBdyW / 3,
            flexDirection: 'column',
            justifyContent: 'space-around',
            alignItems: 'center',
          }
        }, [

          ce.c(ce.Msg, {
            key: -1,
            pfx: '',
            stlCta: {
              height: ic.s(2),
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            },
            stlPfx: {
              textAlign: 'center',
            },
          }),

          ce.c(ce.Btn, {
            key: -2,
            b_vsb: true,
            b_rvs: false,
            pfx: '基本設定',
            o_onPrs: () => {
              let _d_pageInfs = {
                sgc_pageRole: global.t?.state.sgc_pageRole,
                sgc_pageName: 'iStg1',
                sgc_pageMode: 'show',
              };
              cf.myRN_move_fwd(_d_pageInfs);
            },
            stlCta: {
              height: ic.s(6),
            },
            stlBtn: {
              width: ic.gn_btnWLrg * 2,
              backgroundColor: ic.o_getCcd('p'),
            },
            stlPfx: {
              lineHeight: ic.s(6),
              fontSize: ic.s(1.2),
            },
          }),

          ce.c(ce.Msg, {
            key: -3,
            pfx: '',
            stlCta: {
              height: ic.s(6),
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            },
            stlPfx: {
              textAlign: 'center',
            },
          }),
        
        ]),
      );
    };

    return (
      ce.c(ce.RootDtl, {
        key: -1,
        d_hdrs: {
          pfx: 'ホーム',
          d_subs: {
            iconName: 'users',
            pfx: 'ユーザ切替',
            o_onPrs: () => {
              let _d_pageInfs = {
                sgc_pageRole: global.t?.state.sgc_pageRole,
                sgc_pageName: 'c00v2a',
                sgc_pageMode: 'show',
              };
              cf.myRN_move_fwd(_d_pageInfs);
            },
          },
        },
        d_bdys: {
          stlCta: {
            height: ic.gn_bdyH,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          },
          l_clds: [
            (ff.f(_l0)) ?
              ce.c(ce.Box, {
                key: -10,
                stlCta: {
                  width: global.t?.state.sgcd_dmns.n_bdyW,
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  flexWrap: 'wrap',
                }
              }, _l0)
            : null,
            ce.c(ce.Box, {
              key: -20,
              stlCta: {
                width: global.t?.state.sgcd_dmns.n_bdyW,
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
              }
            }, _l1),
            ce.c(ce.Box, {
              key: -30,
              stlCta: {
                width: global.t?.state.sgcd_dmns.n_bdyW,
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
              }
            }, _l2),

          ]
        }
      })
    );
  };
};


